import { useMemo } from 'react';
import { usePrivateTemplateTagsData } from '../../../../../../../../shared/libs/templates/private';

/**
 * Хук для получения и фильтрации тегов по поисковому запросу.
 * Использует API-запрос `useGetAllQuery` и фильтрует результаты по `search`.
 */
export const useFilteredTemplateTags = (search: string) => {
	const { tags } = usePrivateTemplateTagsData();

	const { templateTags } = tags || {};

	const filteredTags = useMemo(() => {
		if (!templateTags || !Array.isArray(templateTags)) {
			return [];
		}

		return templateTags.filter(
			tag => tag?.name?.toLowerCase().startsWith(search.toLowerCase()),
		);
	}, [templateTags, search]);

	return { filteredTags };
};
